// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary_summary__2JfNM","actions":"summary_actions__35csv","submit":"summary_submit__2xgl4","exit":"summary_exit__2K4gW"};